/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */
export const REQUEST_MANAGER_PERSONS = 'REQUEST_MANAGER_PERSONS';
export const REQUEST_MANAGER_PERSONS_SUCCESS = 'REQUEST_MANAGER_PERSONS_SUCCESS';
export const REQUEST_MANAGER_PERSONS_FAILURE = 'REQUEST_MANAGER_PERSONS_FAILURE';

export const REQUEST_MANAGER_PERSON = 'REQUEST_MANAGER_PERSON';
export const REQUEST_MANAGER_PERSON_SUCCESS = 'REQUEST_MANAGER_PERSON_SUCCESS';
export const REQUEST_MANAGER_PERSON_FAILURE = 'REQUEST_MANAGER_PERSON_FAILURE';

export const REQUEST_ADD_MANAGER_PERSON = 'REQUEST_ADD_MANAGER_PERSON';
export const REQUEST_ADD_MANAGER_PERSON_SUCCESS = 'REQUEST_ADD_MANAGER_PERSON_SUCCESS';
export const REQUEST_ADD_MANAGER_PERSON_FAILURE = 'REQUEST_ADD_MANAGER_PERSON_FAILURE';

export const REQUEST_UPDATE_MANAGER_PERSON = 'REQUEST_UPDATE_MANAGER_PERSON';
export const REQUEST_UPDATE_MANAGER_PERSON_SUCCESS = 'REQUEST_UPDATE_MANAGER_PERSON_SUCCESS';
export const REQUEST_UPDATE_MANAGER_PERSON_FAILURE = 'REQUEST_UPDATE_MANAGER_PERSON_FAILURE';

export const REQUEST_DELETE_MANAGER_PERSON = 'REQUEST_DELETE_MANAGER_PERSON';
export const REQUEST_DELETE_MANAGER_PERSON_SUCCESS = 'REQUEST_DELETE_MANAGER_PERSON_SUCCESS';
export const REQUEST_DELETE_MANAGER_PERSON_FAILURE = 'REQUEST_DELETE_MANAGER_PERSON_FAILURE';